import linkedin from "../images/linkedin.svg";
/* import instagram from "../images/instagram.svg"; */
import gitHub from "../images/github.svg";
/* import wp from "../images/wp.svg"; */
/* import facebook from "../images/facebook.svg"; */
import twitter from "../images/twitter.svg";

const redesContacto = [
  {
    id: 0,
    red: "linkedin",
    img: linkedin,
    url: "https://www.linkedin.com/in/santiago-pulido-pel%C3%A1ez-44684519a/",
  },
  {
    id: 1,
    red: "twitter",
    img: twitter,
    url: "https://twitter.com/santiagop0110",
  },
  /* {
    id: 2,
    red: "whatsApp",
    img: wp,
    url:
      "https://api.whatsapp.com/send?phone=573122097086&text=Hola%20quiero%20contactarme%20contigo!",
  }, */
  {
    id: 3,
    red: "gitHub",
    img: gitHub,
    url: "https://github.com/SantiagoPulidoP/",
  },
  /*   {
    id: 4,
    red: "facebook",
    img: facebook,
    url: "https://www.facebook.com/santipulido10",
  }, */
];

export default redesContacto;
